"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPortfolioCovenantLoanTapeMetadataParams = exports.isAllPortfolioCovenantLoanTapeMetadataParams = exports.isPortfolioCovenantLoanTapeMetadataArray = exports.isPortfolioCovenantLoanTapeMetadata = exports.isSuccessPortfolioCovenantWithCreatedAt = exports.isInitializedOrErrorPortfolioCovenantWithId = exports.isSuccessPortfolioCovenantWithIdAndVersion = exports.isPortfolioCovenantWorklease = void 0;
const _ = __importStar(require("lodash"));
const schema = __importStar(require("../schema"));
const typeguardUtils_1 = require("./typeguardUtils");
const _isSuccessPortfolioCovenantWithCreatedAt = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.SuccessPortfolioCovenantWithCreatedAtSchema,
    typeguardName: 'isSuccessPortfolioCovenantWithCreatedAt',
});
exports.isPortfolioCovenantWorklease = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.PortfolioCovenantWorkleaseSchema,
    typeguardName: 'isPortfolioCovenantWorklease',
});
exports.isSuccessPortfolioCovenantWithIdAndVersion = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.SuccessPortfolioCovenantWithIdAndVersionSchema,
    typeguardName: 'isSuccessPortfolioCovenantWithIdAndVersion',
});
exports.isInitializedOrErrorPortfolioCovenantWithId = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.InitializedOrErrorPortfolioCovenantWithIdSchema,
    typeguardName: 'isInitializedOrErrorPortfolioCovenantWithId',
});
const isSuccessPortfolioCovenantWithCreatedAt = (obj) => {
    if (!(0, typeguardUtils_1.hasCreatedAtAndUpdatedAtJsDate)({
        obj,
        typeName: 'SuccessPortfolioCovenantWithCreatedAt',
    })) {
        return false;
    }
    const stringifiedTimestamps = {
        ...obj,
        created_at: obj.created_at.toISOString(),
        updated_at: obj.updated_at.toISOString(),
    };
    return _isSuccessPortfolioCovenantWithCreatedAt(stringifiedTimestamps);
};
exports.isSuccessPortfolioCovenantWithCreatedAt = isSuccessPortfolioCovenantWithCreatedAt;
exports.isPortfolioCovenantLoanTapeMetadata = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.PortfolioCovenantLoanTapeMetadataSchema,
    typeguardName: 'isPortfolioCovenantLoanTapeMetadata',
});
const isPortfolioCovenantLoanTapeMetadataArray = (obj, logOptions) => Array.isArray(obj) &&
    _.every((el) => (0, exports.isPortfolioCovenantLoanTapeMetadata)(el, logOptions));
exports.isPortfolioCovenantLoanTapeMetadataArray = isPortfolioCovenantLoanTapeMetadataArray;
exports.isAllPortfolioCovenantLoanTapeMetadataParams = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.AllPortfolioCovenantLoanTapeMetadataParamsSchema,
    typeguardName: 'isAllPortfolioCovenantLoanTapeMetadataParams',
});
exports.isPortfolioCovenantLoanTapeMetadataParams = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.PortfolioCovenantLoanTapeMetadataParamsSchema,
    typeguardName: 'isPortfolioCovenantLoanTapeMetadataParams',
});
//# sourceMappingURL=portfolioCovenant.js.map